import { clockTime } from "./day-model.mjs";

const MINUTE = 60000;

export function timelineWindow(report, fullDay = false) {
    const lower = Date.parse(report.inizio_giornata), upper = Date.parse(report.fine_giornata);
    const bounds = report.presenze.flatMap(p => [p.ingresso, p.uscita, p.inizio, p.fine])
        .filter(Boolean).map(Date.parse).filter(Number.isFinite);
    if (fullDay || !bounds.length) return { start: lower, end: upper };
    const first = Math.max(lower, Math.min(...bounds)), last = Math.min(upper, Math.max(...bounds));
    let start = Math.max(lower, Math.floor(first / (30 * MINUTE)) * 30 * MINUTE - 30 * MINUTE);
    const end = Math.min(upper, Math.max(Math.ceil(last / (30 * MINUTE)) * 30 * MINUTE + 30 * MINUTE, start + 120 * MINUTE));
    start = Math.max(lower, Math.min(start, end - 120 * MINUTE));
    return end > start ? { start, end } : { start: lower, end: upper };
}

export function timelineTicks(window, report) {
    return Array.from({ length: 5 }, (_, i) => {
        const time = window.start + (window.end - window.start) * i / 4;
        return i === 4 && time === Date.parse(report.fine_giornata) ? "24:00" : clockTime(time);
    });
}

// Split only the API's outside-presence segments. Lunch never changes totals.
export function lunchSegments(segments, day) {
    const noonUtc = Date.parse(`${day}T12:00:00Z`);
    const localHour = Number(clockTime(noonUtc).split(":")[0]);
    const lunchStart = noonUtc + (12 - localHour) * 60 * MINUTE, lunchEnd = lunchStart + 60 * MINUTE;
    return segments.flatMap(segment => {
        const start = Date.parse(segment.inizio), end = Date.parse(segment.fine);
        if (segment.tipo !== "fuori_presenza" || end <= lunchStart || start >= lunchEnd) return [segment];
        return [
            [start, Math.min(end, lunchStart), "fuori_presenza"],
            [Math.max(start, lunchStart), Math.min(end, lunchEnd), "pausa"],
            [Math.max(start, lunchEnd), end, "fuori_presenza"],
        ].filter(([a, b]) => b > a).map(([a, b, tipo]) => ({
            ...segment, tipo, inizio: new Date(a).toISOString(), fine: new Date(b).toISOString(), minuti: (b - a) / MINUTE,
        }));
    });
}

export function visibleSegments(segments, window) {
    return segments.filter(s => Date.parse(s.fine) > window.start && Date.parse(s.inizio) < window.end);
}

export function segmentPosition(segment, window) {
    const start = Math.max(window.start, Date.parse(segment.inizio)), end = Math.min(window.end, Date.parse(segment.fine));
    const span = window.end - window.start;
    return { left: `${100 * (start - window.start) / span}%`, width: `${100 * Math.max(0, end - start) / span}%` };
}

export function timelineRows(segments, onlyIdle = false) {
    return segments.filter(s => s.tipo === "tempo_morto" || (!onlyIdle && s.tipo === "attivita"));
}
